export default {
    // 全局主题颜色
    globalThemeColor: '#2184da',
    // 全局主题 hover 颜色
    globalThemeHoverColor: '#e6f7ff',
    // 全局背景颜色
    // globalBackgroundColor: '#ffffff',
    // globalBackgroundColor: '#f2f2f2',
    globalBackgroundColor: '#f7f8fa',
    // box-shadow: 0 2px 3px 0 rgba(0,0,0,.2);
    // 全局默认边框颜色
    globalBorderColor: '#dedede',
    // 头部高度
    headerHeight: '50px',
    // 内容宽度
    contentWidth: '1360px',

    // Default
    colorDefault: '#ffffff',
    // Processing
    colorProcessing: '#1890ff',
    // Success
    colorSuccess: '#52c41a',
    // Warning
    colorWarning: '#faad14',
    // Error
    colorError: '#f5222d',
    // Danger
    colorDanger: '#ff4d4f',

    // grey
    colorGrey: '#d9d9d9',
    // pink
    colorPink: '#eb2f96',
    // red
    colorRed: '#f5222d',
    // yellow
    colorYellow: '#fadb14',
    // orange
    colorOrange: '#fa8c16',
    // cyan
    colorCyan: '#13c2c2',
    // green
    colorGreen: '#52c41a',
    // blue
    colorBlue: '#1890ff',
    // geekblue
    colorGeekblue: '#2f54eb',
    // volcano
    colorVolcano: '#fa541c',
    // gold
    colorGold: '#faad14',
    // lime
    colorLime: '#a0d911'
};
